import { Button } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import type { ReportJobStatuses, ReportJobTypes } from '@vy/types';
import { REPORT_JOB_TYPES } from '@vy/types';
import { REPORT_JOB_STATUSES } from '@vy/types';
import { raiseUnreachable } from '@vy/utils';
import { Link } from 'react-router-dom';

type OpenReportButtonProps = {
  reportId: string;
  status: ReportJobStatuses;
  type: ReportJobTypes;
};

export const OpenReportButton: React.FC<OpenReportButtonProps> = ({ reportId, status, type }) => {
  const isJobCompleted = status === REPORT_JOB_STATUSES.Completed;

  return isJobCompleted ? (
    <Button
      component={Link}
      variant="outlined"
      size="small"
      color="primary"
      to={`/reports/${getNavigationPath(type)}/${reportId}`}
      endIcon={<VyIcon icon="LinkShear" style={{ transform: 'scale(0.8)' }} />}
    >
      Open
    </Button>
  ) : null;
};

function getNavigationPath(reportType: ReportJobTypes): string {
  switch (reportType) {
    case REPORT_JOB_TYPES.CommitmentUsage:
      return 'commitment-usage';
    case REPORT_JOB_TYPES.UnchargedUsage:
      return 'uncharged-usage';
    case REPORT_JOB_TYPES.ProductsUsage:
      return 'product';
    case REPORT_JOB_TYPES.CustomerRevenue:
      return 'customer-revenue';
    case REPORT_JOB_TYPES.Contracts:
      return 'contracts';
    case REPORT_JOB_TYPES.AnonymousCustomers:
      return 'anonymous-customers';
    case REPORT_JOB_TYPES.MonthlyClosure:
      return 'monthly-closure';
    case REPORT_JOB_TYPES.Customers:
      return 'customers';
    case REPORT_JOB_TYPES.UpcomingInvoices:
      return 'upcoming-invoices';
    case REPORT_JOB_TYPES.UnapprovedInvoices:
      return 'unapproved-invoices';
    case REPORT_JOB_TYPES.FailedInvoiceDeliveries:
      return 'failed-invoice-deliveries';
    case REPORT_JOB_TYPES.Usage:
      return 'usage';
    case REPORT_JOB_TYPES.RecurringRevenue:
      return 'recurring-revenue';
    default:
      return raiseUnreachable(reportType);
  }
}
